// extracted by mini-css-extract-plugin
module.exports = {"articleItem":"ArticleItem_articleItem__zdwjm","articleTitle":"ArticleItem_articleTitle__lvSYo","icon":"ArticleItem_icon__3Xjmt","articleText":"ArticleItem_articleText__BMMDG"};